/*
 * OZ Upsells (2026-10-15): the storefront behaviour of the Upsells app (Upsells repo: AGREED-SPEC 6, 12 to 15;
 * CONTRACTS 5.3 to 5.5, 6 and 7.1). Loaded by layout/theme.liquid on the default product template and the cart page.
 * The HTML from Liquid is the final first paint (snippets/oz-upsells-*.liquid); this file only reacts: to taps, to a
 * variant change, to scrolling, and to time passing a promotion boundary or a funnel's end.
 *
 *   OzBuy.upsell        the upsell step of assets/oz-buy.js (it may load before or after this file):
 *     decide(ctx)       synchronous; true when the pop-up has something to offer for ctx.kind (a tile whose funnel
 *                       opens on that button, in scope for the chosen variant, not already in the cart or switched on),
 *                       or a section with more pages to load whose funnels open on that button (data-oz-kinds)
 *     open(ctx)         shows "Complete your order" (shuffle start picked, kinds, scope, selections and the cart
 *                       applied while it is still hidden), then re-reads /cart.js; if nothing is left (now, or once
 *                       the lazy pages it waited for are in) it closes and continues (oz_upsells:error empty_open). Continue -> ctx.proceed(items with _upsell), "No thanks" -> ctx.proceed([]),
 *                       back / X / Escape / backdrop -> ctx.cancel()
 *   in-page rows        on variant:changed re-runs the merge's render step over the rows in DOM order (scope, then
 *                       de-duplication), unchecks rows that hide, re-prices for the new basis and fires `change` so
 *                       the running total refreshes (assets/oz-pdp.js); the row dropdown swaps the option
 *   cart block          its plus adds at once (/cart/add.js with _upsell and the cart section, whose HTML replaces the
 *                       cart), then publishes oz_upsells:add
 *   lazy pages          grids load the next queued page as they scroll into view, rows near their end or on an arrow
 *                       (24 tiles at most per row); the first queued page of each section is prefetched when idle.
 *                       ?section_id=oz-upsells-more&<page_param>=<n> (or ?view=oz-upsells-more, SPIKE lazyMode), the
 *                       name corrected from the response when it differs; tiles already in the block are dropped
 *   events              oz_upsells:view (tiles and rows at least half visible, once each per page view, batched every
 *                       second, 50 items at most), oz_upsells:error (empty_open, lazy_failed, add_422, ns_missing)
 *   boundary            when a promotion window opens or closes (data-oz-price "at"), prices switch to the steps after
 *                       it ("a"); when a funnel's end passes (data-oz-ends), its tiles and rows hide. On a page left open
 *                       or served from a cache, no fetch is needed.
 *
 * Prices: data-oz-price is {"s": [[threshold, final, was, tag], ...], "at": epoch, "a": steps after at | null}; the
 * shopper sees the last step whose threshold is at or below the basis (the cart without _upsell lines, plus the
 * chosen variant on the product page). Money as formatMoney in the Upsells repo: $19.95, $29, $1,299.
 */
(function () {
  'use strict';

  var ROW_MAX = 24;
  var EVENT_ITEMS = 50;
  var VIEW_DELAY = 1000;
  var LABEL_NO = 'No thanks';
  var LABEL_CART = 'Continue to cart';
  var LABEL_CHECKOUT = 'Continue to checkout';

  var OzBuy = window.OzBuy = window.OzBuy || {};

  /* ---------- helpers ---------- */
  function all(root, selector) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function nowSec() { return Math.floor(Date.now() / 1000); }
  function parseJson(text) { try { return JSON.parse(text); } catch (e) { return null; } }
  function setHidden(el, hidden) { if (el && el.hidden !== hidden) { el.hidden = hidden; } }
  function set(text) {
    var out = {};
    String(text || '').split(',').forEach(function (x) { if (x) { out[x] = true; } });
    return out;
  }
  function money(cents) {
    var c = Math.max(0, Math.round(Number(cents) || 0));
    var dollars = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var rest = c % 100;
    return '$' + dollars + (rest ? '.' + (rest < 10 ? '0' : '') + rest : '');
  }
  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function fire(el, name) {
    var event;
    try { event = new Event(name, { bubbles: true }); } catch (e) { event = document.createEvent('Event'); event.initEvent(name, true, false); }
    el.dispatchEvent(event);
  }

  /* ---------- events (CONTRACTS 7.1) ---------- */
  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics never breaks the page */ }
  }
  function publishError(code, detail) {
    publish('oz_upsells:error', { v: 1, code: code, detail: String(detail || '').slice(0, 120) });
  }
  function itemOf(el, withQuantity) {
    var item = [
      Number(el.getAttribute('data-oz-fkey')) || 0,
      Number(el.getAttribute('data-oz-skey')) || 0,
      Number(el.getAttribute('data-oz-ckey')) || 0,
      Number(el.getAttribute('data-oz-pid')) || 0,
      Number(currentVariant(el)) || 0
    ];
    if (withQuantity) { item.push(1); }
    return item;
  }
  function currentVariant(el) {
    if (el.hasAttribute('data-oz-row')) {
      var input = el.querySelector('input.related_product_block_check_input');
      return input ? input.value : 0;
    }
    return el.getAttribute('data-oz-vid');
  }
  function placementOf(el) {
    if (el.hasAttribute('data-oz-row')) { return 'i'; }
    var token = el.getAttribute('data-oz-token') || '';
    return token.charAt(3) || 'p';
  }

  var views = { seen: {}, queue: {}, timer: 0, observer: null };
  function flushViews() {
    views.timer = 0;
    Object.keys(views.queue).forEach(function (pl) {
      var list = views.queue[pl];
      for (var i = 0; i < list.length; i += EVENT_ITEMS) {
        publish('oz_upsells:view', { v: 1, pl: pl, items: list.slice(i, i + EVENT_ITEMS) });
      }
    });
    views.queue = {};
  }
  function sawElement(el) {
    if (el.hidden || el.closest('[hidden]')) { return; }
    var pl = placementOf(el);
    var key = pl + '|' + (el.getAttribute('data-oz-fkey') || '') + '|' + (el.getAttribute('data-oz-ckey') || '') + '|' + currentVariant(el);
    if (views.seen[key]) { return; }
    views.seen[key] = true;
    (views.queue[pl] = views.queue[pl] || []).push(itemOf(el, false));
    if (!views.timer) { views.timer = setTimeout(flushViews, VIEW_DELAY); }
  }
  function watchViews(root) {
    if (!('IntersectionObserver' in window)) { return; }
    if (!views.observer) {
      views.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { sawElement(entry.target); }
        });
      }, { threshold: [0.5] });
    }
    all(root, '[data-oz-tile], [data-oz-row]').forEach(function (el) {
      if (el.__ozViewed) { return; }
      el.__ozViewed = true;
      views.observer.observe(el);
    });
  }

  /* ---------- prices (CONTRACTS 5.4) ---------- */
  function priceOf(el) {
    var p = parseJson(el.getAttribute('data-oz-price'));
    if (!p || !p.s || !p.s.length) { return null; }
    if (p.at && p.a && nowSec() >= p.at) { return { s: p.a, at: 0, a: null }; }
    return p;
  }
  // The step the shopper sees for `basis`, and the "Deal from" threshold (a later step with a lower price).
  function pick(price, basis) {
    var steps = price.s;
    var shown = steps[0];
    var index = 0;
    for (var i = 0; i < steps.length; i++) { if (steps[i][0] <= basis) { shown = steps[i]; index = i; } }
    var deal = 0;
    for (var j = index + 1; j < steps.length; j++) {
      if (steps[j][0] > basis && steps[j][1] < shown[1]) { deal = steps[j][0]; break; }
    }
    return { final: shown[1], was: shown[2], tag: shown[3] || '', pill: shown[4] || '', deal: deal };
  }
  // The tag's look from a step's pill (snippets/oz-upsells-price.liquid): 's' a violet "Save $X" (class is-save), else a
  // promotion's "<bg> <fg>" colours as --oz-tag-bg and --oz-tag-fg (Dereck 2026-10-16), '' nothing.
  function paintTag(tag, text, pill) {
    if (tag.textContent !== text) { tag.textContent = text; }
    setHidden(tag, !text);
    var save = pill === 's';
    if (tag.classList.contains('is-save') !== save) { tag.classList.toggle('is-save', save); }
    var pair = !save && pill ? pill.split(' ') : null;
    var bg = pair ? pair[0] : '';
    var fg = pair ? pair[1] || '' : '';
    if (tag.style.getPropertyValue('--oz-tag-bg') !== bg) { if (bg) { tag.style.setProperty('--oz-tag-bg', bg); } else { tag.style.removeProperty('--oz-tag-bg'); } }
    if (tag.style.getPropertyValue('--oz-tag-fg') !== fg) { if (fg) { tag.style.setProperty('--oz-tag-fg', fg); } else { tag.style.removeProperty('--oz-tag-fg'); } }
    if (!tag.getAttribute('style')) { tag.removeAttribute('style'); }
  }
  function fillDetail(el, template, final, base) {
    if (!el || !template) { return; }
    // {price/N}: the price split into N parts, half up to the cent (snippets/oz-upsells-fill.liquid, the same rule)
    var text = template.replace(/\{price\/([1-9]\d{0,2})\}/g, function (m, n) { n = Number(n); return money(Math.floor((2 * final + n) / (2 * n))); })
      .replace(/\{price\}/g, money(final))
      .replace(/\{save\}/g, money(Math.max(0, base - final)));
    if (el.textContent !== text) { el.textContent = text; }
  }
  function renderTilePrice(tile, basis) {
    var price = priceOf(tile);
    if (!price) { return null; }
    var p = pick(price, basis);
    var box = tile.querySelector('[data-oz-pricebox]');
    if (box) {
      var html = '<b' + (p.was > 0 ? ' class="is-sale"' : '') + '>' + money(p.final) + '</b>' + (p.was > 0 ? '<s>' + money(p.was) + '</s>' : '');
      if (box.innerHTML !== html) { box.innerHTML = html; }
    }
    var tag = tile.querySelector('[data-oz-tag]');
    if (tag) { paintTag(tag, p.tag, p.pill); }
    var deal = tile.querySelector('[data-oz-deal]');
    if (deal) {
      var text = p.deal ? 'Deal from ' + money(p.deal) + ' cart total' : '';
      if (deal.textContent !== text) { deal.textContent = text; }
      setHidden(deal, !p.deal);
    }
    fillDetail(tile.querySelector('[data-oz-detail]'), tile.getAttribute('data-oz-detail-tpl'), p.final, Number(tile.getAttribute('data-oz-base')) || 0);
    tile.__ozFinal = p.final;
    return p;
  }
  function renderRowPrice(row, basis) {
    var input = row.querySelector('input.related_product_block_check_input');
    if (!input) { return null; }
    var price = priceOf(input);
    if (!price) { return null; }
    var p = pick(price, basis);
    if (input.getAttribute('data-price') !== String(p.final)) { input.setAttribute('data-price', String(p.final)); }
    var box = row.querySelector('[data-oz-pricebox]');
    if (box) {
      var html = '<b>+' + money(p.final) + '</b>' + (p.was > 0 ? '<s class="oz-prot__was">' + money(p.was) + '</s>' : '');
      if (box.innerHTML !== html) { box.innerHTML = html; }
    }
    var tag = row.querySelector('[data-oz-tag]');
    if (tag) {
      paintTag(tag, p.tag, p.pill === 's' ? '' : p.pill);
      row.classList.toggle('oz-prot__row--tagged', !!p.tag);
    }
    fillDetail(row.querySelector('[data-oz-detail]'), row.getAttribute('data-oz-detail-tpl'), p.final, Number(input.getAttribute('data-oz-base')) || 0);
    return p;
  }

  /* ---------- options (one variant each, CONTRACTS 5.3 step 4) ---------- */
  function optionList(el) {
    var select = el.querySelector('select[data-oz-options]');
    return select ? all(select, 'option') : [];
  }
  function applyTileOption(tile, option) {
    var select = tile.querySelector('select[data-oz-options]');
    if (select && select.value !== option.value) { select.value = option.value; }
    tile.setAttribute('data-oz-pid', option.getAttribute('data-oz-pid'));
    tile.setAttribute('data-oz-vid', option.value);
    tile.setAttribute('data-oz-base', option.getAttribute('data-oz-base') || '');
    tile.setAttribute('data-oz-price', option.getAttribute('data-oz-price'));
    // a cart service tile listing the devices (snippets/oz-upsells-block.liquid step 7): each entry is its own device's
    // tile, so its token and keys follow it and the plus adds that device's service with its own _upsell
    if (option.hasAttribute('data-oz-token')) {
      ['data-oz-token', 'data-oz-fkey', 'data-oz-skey', 'data-oz-ckey', 'data-oz-src', 'data-oz-kinds', 'data-oz-vs'].forEach(function (name) {
        tile.setAttribute(name, option.getAttribute(name) || '');
      });
      var ends = Number(option.getAttribute('data-oz-ends')) || 0;
      if (ends > 0) { tile.setAttribute('data-oz-ends', String(ends)); } else { tile.removeAttribute('data-oz-ends'); }
    }
    var img = tile.querySelector('.oz-up__img');
    var src = option.getAttribute('data-oz-img');
    if (img) {
      if (src) { if (img.getAttribute('src') !== src) { img.setAttribute('src', src); } img.hidden = false; } else { img.hidden = true; }
    }
    var title = tile.querySelector('[data-oz-title]');
    var t = option.getAttribute('data-oz-title') || '';
    if (title && title.textContent !== t) { title.textContent = t; }
    var add = tile.querySelector('[data-oz-add]');
    if (add) { add.setAttribute('aria-label', 'Add ' + t); }
    var detail = tile.querySelector('[data-oz-detail]');
    var d = option.getAttribute('data-oz-detail') || '';
    if (detail && !tile.hasAttribute('data-oz-detail-tpl')) {
      if (detail.textContent !== d) { detail.textContent = d; }
      setHidden(detail, !d);
    }
    syncOptBtn(tile);
  }
  function applyRowOption(row, option) {
    var select = row.querySelector('select[data-oz-options]');
    if (select && select.value !== option.value) { select.value = option.value; }
    var input = row.querySelector('input.related_product_block_check_input');
    row.setAttribute('data-oz-pid', option.getAttribute('data-oz-pid'));
    input.value = option.value;
    input.setAttribute('data-oz-base', option.getAttribute('data-oz-base') || '');
    input.setAttribute('data-oz-price', option.getAttribute('data-oz-price'));
    var title = row.querySelector('[data-oz-title]');
    var t = option.getAttribute('data-oz-title') || '';
    if (title && t && title.textContent !== t) { title.textContent = t; }
    var detail = row.querySelector('[data-oz-detail]');
    var d = option.getAttribute('data-oz-detail') || '';
    if (detail && !row.hasAttribute('data-oz-detail-tpl') && d && detail.textContent !== d) { detail.textContent = d; }
    var photo = row.querySelector('[data-oz-photo-img]');
    var src = option.getAttribute('data-oz-img');
    if (photo && src && photo.getAttribute('src') !== src) { photo.setAttribute('src', src); }
    syncOptBtn(row);
  }

  /* ---------- in-page rows (CONTRACTS 5.3 step 4, 6.2) ---------- */
  function rowGroups(section) { return all(section, '[data-oz-upsells-rows]'); }
  /* ---------- the price basis (interfaces.md 5.4) ----------
   * The cart without _upsell lines, plus the chosen variant only for the quantity the cart does not already hold of it
   * as a plain line: after an express tap the phone is in the cart once, and Shop Pay and Checkout never add a second,
   * so counting it again would show a "minimum cart" price that checkout will not give (S5-8). Liquid prints
   * data-oz-cart-basis and data-oz-cart-vq (",<variant id>:<quantity>,..." of the plain lines); a fresh /cart.js read
   * replaces both (cartSnapshot). */
  function cartSnapshot(cart) {
    var out = { ids: ',', basis: 0, vq: ',' };
    var held = {};
    (cart && cart.items || []).forEach(function (line) {
      if (out.ids.indexOf(',' + line.product_id + ',') < 0) { out.ids += line.product_id + ','; }
      if (!(line.properties && line.properties._upsell)) {
        out.basis += Number(line.original_line_price) || 0;
        held[line.variant_id] = (held[line.variant_id] || 0) + (Number(line.quantity) || 0);
      }
    });
    Object.keys(held).forEach(function (vid) { out.vq += vid + ':' + held[vid] + ','; });
    return out;
  }
  function applySnapshot(el, snap) {
    el.setAttribute('data-oz-incart', snap.ids);
    el.setAttribute('data-oz-cart-basis', String(snap.basis));
    el.setAttribute('data-oz-cart-vq', snap.vq);
  }
  function heldOf(el, variantId) {
    var m = new RegExp(',' + Number(variantId) + ':(\\d+),').exec(el.getAttribute('data-oz-cart-vq') || '');
    return m ? Number(m[1]) : 0;
  }
  function wantedQty(section) {
    var input = section && section.querySelector('form[action*="/cart/add"] [name="quantity"]');
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }
  function pageBasis(el, variant, wanted) {
    var cartBasis = Number(el.getAttribute('data-oz-cart-basis')) || 0;
    if (!variant) { return cartBasis; }
    return cartBasis + (Number(variant.price) || 0) * Math.max(0, (wanted || 1) - heldOf(el, variant.id));
  }

  function recheckRows(group, variant) {
    if (!variant) { return; }
    var basis = pageBasis(group, variant, wantedQty(productSection(group)));
    // in-page rows show even what is already in the cart (Dereck 2026-10-15: "they might get another phone")
    var claimed = {};
    claimed[group.getAttribute('data-oz-main-pid')] = true;
    var vk = ',' + variant.id + ',';
    var now = nowSec();
    var changed = [];
    all(group, '[data-oz-row]').forEach(function (row) {
      var input = row.querySelector('input.related_product_block_check_input');
      var vs = row.getAttribute('data-oz-vs') || '';
      var ends = Number(row.getAttribute('data-oz-ends')) || 0;
      var inScope = (!vs || vs.indexOf(vk) >= 0) && !(ends && now >= ends);
      var options = optionList(row);
      var free = [];
      if (options.length) {
        options.forEach(function (o) {
          var pid = o.getAttribute('data-oz-pid');
          var ok = !claimed[pid];
          if (o.hidden === ok) { o.hidden = !ok; }
          if (o.disabled === ok) { o.disabled = !ok; }
          if (ok) { free.push(o); }
        });
      } else if (!claimed[row.getAttribute('data-oz-pid')]) {
        free.push(null);
      }
      var visible = inScope && free.length > 0;
      if (visible) {
        if (options.length) {
          var select = row.querySelector('select[data-oz-options]');
          var current = select.options[select.selectedIndex];
          if (!current || current.disabled) { applyRowOption(row, free[0]); }
          free.forEach(function (o) { claimed[o.getAttribute('data-oz-pid')] = true; });
        } else {
          claimed[row.getAttribute('data-oz-pid')] = true;
        }
      } else if (input && input.checked) {
        input.checked = false;
        changed.push(input);
      }
      setHidden(row, !visible);
      var before = input ? input.getAttribute('data-price') : null;
      renderRowPrice(row, basis);
      if (input && input.checked && before !== input.getAttribute('data-price')) { changed.push(input); }
    });
    // the running total (assets/oz-pdp.js) listens for change on the switches
    if (changed.length) { fire(changed[0], 'change'); }
    watchViews(group);
  }

  /* ---------- the pop-up ---------- */
  var current = null; // { root, ctx, opener, lastFocus, keydown, backdrop }

  function productSection(el) { return el && el.closest ? el.closest('[data-section-type="product"]') : null; }
  function popupFor(section) {
    if (!section) { return null; }
    return section.__ozUpPopup || section.querySelector('[data-oz-upsells-popup]');
  }
  function productJson(section) {
    var el = section && section.querySelector('[data-product-json]');
    var data = el ? parseJson(el.textContent || el.innerHTML) : null;
    return data && data.product ? data.product : data;
  }
  function variantById(section, id) {
    var product = productJson(section);
    var list = (product && product.variants) || [];
    for (var i = 0; i < list.length; i++) { if (Number(list[i].id) === Number(id)) { return list[i]; } }
    return null;
  }
  function variantLabel(section, variant) {
    var product = productJson(section);
    var title = (product && product.title) || '';
    var parts = [title];
    (variant && variant.options ? variant.options : []).forEach(function (o) { if (o && title.indexOf(o) < 0) { parts.push(o); } });
    return parts.join(' · ');
  }

  // What the shopper must not be offered again: the cart and every switched-on selection (products and variants).
  function exclusions(root, ctx, incartText) {
    var out = { pids: set(incartText), vids: {} };
    out.pids[root.getAttribute('data-oz-main-pid')] = true;
    (ctx.selections || []).forEach(function (item) { out.vids[String(item.id)] = true; });
    all(ctx.section, '.related_product_block_check_input:checked').forEach(function (input) {
      var row = input.closest('[data-oz-row]');
      if (row && row.getAttribute('data-oz-pid')) { out.pids[row.getAttribute('data-oz-pid')] = true; }
      out.vids[String(input.value)] = true;
    });
    return out;
  }
  function tileAllowed(tile, kind, vk) {
    var kinds = ',' + (tile.getAttribute('data-oz-kinds') || 'cart,shop,checkout') + ',';
    if (kinds.indexOf(',' + kind + ',') < 0) { return false; }
    var vs = tile.getAttribute('data-oz-vs') || '';
    if (vs && vs.indexOf(vk) < 0) { return false; }
    var ends = Number(tile.getAttribute('data-oz-ends')) || 0;
    return !(ends && nowSec() >= ends);
  }
  function freeOptions(tile, ex) {
    var options = optionList(tile);
    if (!options.length) {
      var pid = tile.getAttribute('data-oz-pid');
      return ex.pids[pid] || ex.vids[tile.getAttribute('data-oz-vid')] ? [] : [null];
    }
    return options.filter(function (o) {
      var ok = !ex.pids[o.getAttribute('data-oz-pid')] && !ex.vids[o.value];
      if (o.disabled === ok) { o.disabled = !ok; }
      if (o.hidden === ok) { o.hidden = !ok; }
      return ok;
    });
  }
  // data-oz-kinds on a section: the union of its funnels' kinds (absent: every kind)
  function sectionAllows(sec, kind) {
    var kinds = sec.getAttribute('data-oz-kinds');
    if (kinds === null || !kind) { return true; }
    return (',' + kinds + ',').indexOf(',' + kind + ',') >= 0;
  }
  // More tiles may still come for this button: a queued or loading page in a section one of whose funnels opens on it
  function hasPending(sec, kind) {
    if (!sectionAllows(sec, kind)) { return false; }
    var st = sectionState(sec);
    return st.queue.length > 0 || st.loading;
  }
  function anyPending(root, kind) {
    return all(root, 'section[data-oz-sec]').some(function (sec) { return hasPending(sec, kind); });
  }
  // Applies kinds, scope, the cart and the selections; returns how many tiles remain offerable.
  function filterPopup(root, ctx, incartText, shuffle) {
    var vk = ',' + (ctx.selections[0] && ctx.selections[0].id) + ',';
    var ex = exclusions(root, ctx, incartText);
    var shown = 0;
    all(root, 'section[data-oz-sec]').forEach(function (sec) {
      var any = false;
      all(sec, '[data-oz-tile]').forEach(function (tile) {
        var free = tileAllowed(tile, ctx.kind, vk) ? freeOptions(tile, ex) : [];
        if (free.length && free[0]) {
          var select = tile.querySelector('select[data-oz-options]');
          var cur = select && select.options[select.selectedIndex];
          if (shuffle && tile.hasAttribute('data-oz-shuffle') && free.length > 1) {
            applyTileOption(tile, free[Math.floor(Math.random() * free.length)]);
          } else if (cur && cur.disabled) {
            applyTileOption(tile, free[0]);
          }
        }
        var off = !free.length;
        if (off) { setPressed(tile, false); }
        setHidden(tile, off);
        if (!off) { any = true; shown++; }
      });
      setHidden(sec, !any && !hasPending(sec, ctx.kind));
    });
    return shown;
  }
  function popupBasis(root, ctx) {
    var variant = variantById(ctx.section, ctx.selections[0] && ctx.selections[0].id);
    // no product JSON to read the price from: the basis Liquid printed for the variant on screen
    if (!variant) { return Number(root.getAttribute('data-oz-basis')) || 0; }
    return pageBasis(root, variant, ctx.selections[0].quantity);
  }
  function repricePopup(root) {
    var basis = root.__ozBasis || 0;
    all(root, '[data-oz-tile]').forEach(function (tile) { renderTilePrice(tile, basis); });
    updateFoot(root);
  }
  function setPressed(tile, on) {
    var add = tile.querySelector('[data-oz-add]');
    if (add && add.getAttribute('aria-pressed') !== String(on)) { add.setAttribute('aria-pressed', String(on)); }
  }
  function pressedTiles(root) {
    return all(root, '[data-oz-tile]').filter(function (tile) {
      var add = tile.querySelector('[data-oz-add]');
      return !tile.hidden && add && add.getAttribute('aria-pressed') === 'true';
    });
  }
  // The pinned wallet (AGREED-SPEC 15): when the pop-up opened from Apple Pay or Google Pay and its copy of Shopify's
  // wallet element has drawn the button, that button is the pinned one; until then (or on a device where it draws
  // nothing) the dark button continues to checkout instead.
  function walletFoot(root) {
    var box = root.querySelector('[data-oz-up-wallet]');
    if (!box) { return null; }
    var on = !!(current && current.root === root && current.ctx.wallet && box.querySelector('shopify-apple-pay-button, shopify-google-pay-button'));
    if (on && current.ctx.walletTag) {
      // only the wallet the shopper tapped (Apple Pay or Google Pay), never both side by side (Dereck 2026-10-16)
      all(box, 'shopify-apple-pay-button, shopify-google-pay-button').forEach(function (el) {
        var keep = el.tagName.toLowerCase() === current.ctx.walletTag;
        if (el.style.display !== (keep ? '' : 'none')) { el.style.display = keep ? '' : 'none'; }
      });
      on = !!box.querySelector(current.ctx.walletTag);
    }
    return { box: box, on: on };
  }
  function watchWalletFoot(root) {
    var box = root.querySelector('[data-oz-up-wallet]');
    if (!box || box.__ozWatched || !('MutationObserver' in window)) { return; }
    box.__ozWatched = true;
    new MutationObserver(function () { if (current && current.root === root) { updateFoot(root); } }).observe(box, { childList: true, subtree: true });
  }
  function updateFoot(root) {
    var button = root.querySelector('[data-oz-up-continue]');
    if (!button || !current || current.root !== root) { return; }
    var tiles = pressedTiles(root);
    var wallet = walletFoot(root);
    if (wallet) {
      setHidden(wallet.box, !wallet.on);
      setHidden(button, wallet.on);
    }
    if (wallet && wallet.on) {
      var total = 0;
      tiles.forEach(function (tile) { total += tile.__ozFinal || 0; });
      var line = wallet.box.querySelector('[data-oz-up-wsum]');
      var text = tiles.length ? tiles.length + ' added · +' + money(total) : '';
      if (line) {
        if (line.textContent !== text) { line.textContent = text; }
        setHidden(line, !text);
      }
      return;
    }
    var html;
    if (!tiles.length) {
      html = LABEL_NO;
      button.classList.remove('has');
    } else {
      var sum = 0;
      tiles.forEach(function (tile) { sum += tile.__ozFinal || 0; });
      var label = current.ctx.kind === 'cart' ? LABEL_CART : LABEL_CHECKOUT;
      html = escapeHtml(label) + '<span>' + tiles.length + ' added · +' + money(sum) + '</span>';
      button.classList.add('has');
    }
    if (button.innerHTML !== html) { button.innerHTML = html; }
  }

  function decide(ctx) {
    var root = popupFor(ctx && ctx.section);
    if (!root || !ctx.selections || !ctx.selections.length) { return false; }
    var vk = ',' + ctx.selections[0].id + ',';
    var ex = exclusions(root, ctx, root.getAttribute('data-oz-incart'));
    var tiles = all(root, '[data-oz-tile]');
    for (var i = 0; i < tiles.length; i++) {
      if (tileAllowed(tiles[i], ctx.kind, vk) && freeOptions(tiles[i], ex).length) { return true; }
    }
    return anyPending(root, ctx.kind);
  }

  function focusables(root) {
    return all(root, 'button, select, a[href], input, [tabindex]:not([tabindex="-1"])').filter(function (el) {
      return !el.disabled && !el.hidden && !el.closest('[hidden]') && el.offsetParent !== null;
    });
  }
  function onKeydown(event) {
    if (!current) { return; }
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      cancelPopup();
      return;
    }
    if (event.key !== 'Tab') { return; }
    var list = focusables(current.root);
    if (!list.length) { return; }
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && (document.activeElement === first || !current.root.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !current.root.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  }
  function show(root) {
    root.hidden = false;
    var ozBar = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.classList.add('oz-up-lock');
    if (ozBar > 0) document.body.style.paddingRight = ozBar + 'px'; // no sideways jump when the scrollbar goes
    var backdrop = document.createElement('div');
    backdrop.className = 'oz-up-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    backdrop.addEventListener('click', cancelPopup);
    // right before the dialog: both sit at the top of the stacking order, so DOM order keeps the dialog above it
    if (root.parentNode === document.body) { document.body.insertBefore(backdrop, root); } else { document.body.appendChild(backdrop); }
    current.backdrop = backdrop;
    current.lastFocus = document.activeElement;
    document.addEventListener('keydown', onKeydown, true);
    var scroller = root.querySelector('[data-oz-up-scroll]');
    if (scroller) { scroller.scrollTop = 0; }
    var focus = focusables(root.querySelector('.oz-up__top'))[0] || root.querySelector('[data-oz-up-continue]');
    if (focus) { focus.focus({ preventScroll: true }); }
  }
  function hide() {
    if (!current) { return null; }
    var was = current;
    current = null;
    if (was.walletWatch) { was.walletWatch.disconnect(); }
    var box = was.root.querySelector('[data-oz-up-wallet]');
    if (box) { box.hidden = true; }
    var button = was.root.querySelector('[data-oz-up-continue]');
    if (button) { button.hidden = false; }
    was.root.hidden = true;
    // the next opening may come from another button: the dark pinned button again, the wallet put away
    var wbox = was.root.querySelector('[data-oz-up-wallet]');
    if (wbox) { setHidden(wbox, true); }
    setHidden(was.root.querySelector('[data-oz-up-continue]'), false);
    document.documentElement.classList.remove('oz-up-lock');
    document.body.style.paddingRight = '';
    document.removeEventListener('keydown', onKeydown, true);
    if (was.backdrop && was.backdrop.parentNode) { was.backdrop.parentNode.removeChild(was.backdrop); }
    if (was.lastFocus && was.lastFocus.focus) { try { was.lastFocus.focus({ preventScroll: true }); } catch (e) { /* gone */ } }
    return was;
  }
  function cancelPopup() {
    if (current && current.busy) { return; } // on its way to the cart: back, X and Escape wait
    var was = hide();
    if (was) { was.ctx.cancel(); }
  }
  function pressedItems(root) {
    return pressedTiles(root).map(function (tile) {
      return { id: Number(tile.getAttribute('data-oz-vid')), quantity: 1, properties: { _upsell: tile.getAttribute('data-oz-token') } };
    });
  }
  // Continue / No thanks: the pop-up stays open and the tapped button shows a spinner while the cart fills, and the
  // browser goes to the cart from there (Dereck 2026-10-16: it used to close at once, show the product page for a few
  // seconds, then jump). If nothing could be done, the pop-up closes as before.
  function continuePopup(button) {
    if (!current || current.busy) { return; }
    var items = pressedItems(current.root);
    var was = current;
    was.busy = true;
    if (button) { button.setAttribute('aria-busy', 'true'); button.classList.add('is-busy'); }
    was.root.classList.add('is-leaving');
    var result = was.ctx.proceed(items);
    var done = function (ok) {
      if (ok) { return; } // the page is leaving; keep the pop-up and spinner up until it does
      was.busy = false;
      if (button) { button.removeAttribute('aria-busy'); button.classList.remove('is-busy'); }
      was.root.classList.remove('is-leaving');
      if (current === was) { hide(); }
    };
    if (result && typeof result.then === 'function') { result.then(done, function () { done(false); }); } else { done(false); }
  }
  // Back from the cart can restore this page from the browser's memory with the pop-up still on its spinner: close it
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !current || !current.busy) { return; }
    var was = current;
    was.busy = false;
    was.root.classList.remove('is-leaving');
    Array.prototype.forEach.call(was.root.querySelectorAll('.is-busy'), function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
    hide();
  });
  // For assets/oz-buy.js's wallet tap on the pinned wallet: the open pop-up's ctx and what it adds. The pop-up stays
  // open behind the sheet; fallback() is the Checkout path when the cart cannot be prepared inside the tap.
  function walletTap() {
    if (!current || !current.ctx.wallet) { return null; }
    var items = pressedItems(current.root);
    return {
      ctx: current.ctx,
      items: items,
      fallback: function () {
        var was = hide();
        if (was) { was.ctx.proceed(items); }
      }
    };
  }

  function open(ctx) {
    var root = popupFor(ctx.section);
    if (!root || current) { ctx.proceed([]); return; }
    // the dialog lives in <body> while it is used, clear of any transformed ancestor; the section keeps a reference
    if (root.parentNode !== document.body) {
      ctx.section.__ozUpPopup = root;
      document.body.appendChild(root);
    }
    var start = function () {
      current = { root: root, ctx: ctx };
      all(root, '[data-oz-tile]').forEach(function (tile) { setPressed(tile, false); });
      var variant = variantById(ctx.section, ctx.selections[0].id);
      var label = root.querySelector('[data-oz-up-label]');
      if (label && variant) { label.textContent = variantLabel(ctx.section, variant); }
      root.__ozBasis = popupBasis(root, ctx);
      filterPopup(root, ctx, root.getAttribute('data-oz-incart'), true);
      watchWalletFoot(root);
      repricePopup(root);
      show(root);
      watchArrows(root);
      all(root, 'section[data-oz-sec]').forEach(updateArrows);
      startLazy(root);
      watchViews(root);
      // the cart may have changed since the page was served (another tab, a cached page): read it again
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !current || current.root !== root) { return; }
          var snap = cartSnapshot(cart);
          applySnapshot(root, snap);
          root.__ozBasis = popupBasis(root, ctx);
          var left = filterPopup(root, ctx, snap.ids, false);
          repricePopup(root);
          if (!left && !anyPending(root, ctx.kind)) {
            publishError('empty_open', 'nothing left after the cart check');
            var was = hide();
            if (was) { was.ctx.proceed([]); }
          }
        }, function () { /* keep the snapshot */ });
    };
    // a variant-scoped pop-up rendered for another variant: wait (briefly) for the refreshed copy
    var pending = root.__ozRefresh;
    if (pending) {
      var done = false;
      var go = function () { if (!done) { done = true; start(); } };
      pending.then(go, go);
      setTimeout(go, 800);
    } else {
      start();
    }
  }

  // The pop-up was rendered for the variant on screen at load. When a variant-scoped funnel is involved
  // (data-oz-vscoped), a variant change fetches the product section for the new variant and swaps the pop-up's
  // content while it is still hidden, so decide() and open() see that variant's merge.
  function refreshPopupFor(section, variant) {
    var root = popupFor(section);
    if (!root || !root.hasAttribute('data-oz-vscoped') || !variant || current) { return; }
    if (String(root.getAttribute('data-oz-main-vid')) === String(variant.id)) { return; }
    var id = section.getAttribute('data-section-id');
    if (!id) { return; }
    var url = window.location.pathname + '?variant=' + encodeURIComponent(variant.id) + '&section_id=' + encodeURIComponent(id);
    root.__ozRefresh = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); }).then(function (html) {
      if (current && current.root === root) { return; }
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var fresh = tpl.content.querySelector('[data-oz-upsells-popup]');
      if (fresh) {
        Array.prototype.slice.call(fresh.attributes).forEach(function (a) { if (a.name !== 'hidden') { root.setAttribute(a.name, a.value); } });
        root.innerHTML = fresh.innerHTML;
      } else {
        all(root, 'section[data-oz-sec]').forEach(function (sec) { sec.parentNode.removeChild(sec); });
        root.setAttribute('data-oz-main-vid', String(variant.id));
      }
      lazyReset(root);
      watchArrows(root);
    }).catch(function () { /* keep what is there */ }).then(function () { root.__ozRefresh = null; });
  }

  /* ---------- lazy pages (CONTRACTS 5.3 step 5, 6.5) ---------- */
  var pageCache = {};
  function blockOf(el) { return el.closest('[data-oz-upsells-popup], [data-oz-upsells-cart]'); }
  function sectionState(sec) {
    if (!sec.__ozLazy) {
      var queue = [];
      String(sec.getAttribute('data-oz-pages') || '').split(',').forEach(function (x) {
        var parts = x.split(':');
        if (parts.length === 2 && /^\d+$/.test(parts[0]) && /^\d+$/.test(parts[1])) { queue.push({ source: Number(parts[0]), page: Number(parts[1]) }); }
      });
      // "N to go": tiles first paint walked, plus each loaded page's count less what first paint already walked of it
      // (data-oz-part "<source>:<page>=<n>", the last mention of a page wins)
      var part = {};
      String(sec.getAttribute('data-oz-part') || '').split(',').forEach(function (x) {
        var m = /^(\d+:\d+)=(\d+)$/.exec(x);
        if (m) { part[m[1]] = Number(m[2]); }
      });
      sec.__ozLazy = { queue: queue, loading: false, failed: false, accounted: Number(sec.getAttribute('data-oz-walked')) || 0, part: part };
    }
    return sec.__ozLazy;
  }
  function lazyReset(block) { all(block, 'section[data-oz-sec]').forEach(function (sec) { sec.__ozLazy = null; }); }
  function srcOf(block, source) {
    var list = parseJson(block.getAttribute('data-oz-srcs')) || [];
    return list[source] || null;
  }
  function pageUrl(block, src, page, param) {
    var join = src.indexOf('?') >= 0 ? '&' : '?';
    if (block.getAttribute('data-oz-lazy') === 'template') {
      return src + join + 'view=oz-upsells-more' + (param ? '&' + encodeURIComponent(param) + '=' + page : '');
    }
    return src + join + 'section_id=oz-upsells-more&' + encodeURIComponent(param || 'page') + '=' + page;
  }
  function fetchPage(url) {
    if (!pageCache[url]) {
      pageCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) { throw new Error('status ' + r.status); }
        return r.text();
      });
      pageCache[url].catch(function () { delete pageCache[url]; });
    }
    return pageCache[url];
  }
  // Reads one page; follows the page_param name the response reports when it differs from the one sent (spike S-C).
  function loadPage(block, entry, tries) {
    var src = srcOf(block, entry.source);
    if (!src) { return Promise.reject(new Error('no source ' + entry.source)); }
    var param = block.getAttribute('data-oz-page-param') || 'page';
    return fetchPage(pageUrl(block, src, entry.page, param)).then(function (html) {
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var page = tpl.content.querySelector('[data-oz-page]');
      if (!page) { throw new Error('no page in the response'); }
      var reported = page.getAttribute('data-oz-page-param');
      if (reported && reported !== param && (tries || 0) < 2) {
        block.setAttribute('data-oz-page-param', reported);
        return loadPage(block, entry, (tries || 0) + 1);
      }
      if (Number(page.getAttribute('data-oz-page')) !== entry.page) {
        // another page came back (fetchPage memoises by URL, so a retry must drop the cached answer); a second
        // mismatch skips this entry
        if (!entry.refetched) {
          entry.refetched = true;
          delete pageCache[pageUrl(block, src, entry.page, param)];
          return loadPage(block, entry, tries);
        }
        var mismatch = new Error('page ' + entry.page + ' answered page ' + page.getAttribute('data-oz-page'));
        mismatch.skip = true;
        throw mismatch;
      }
      return page;
    });
  }
  function blockHas(block) {
    var cards = {};
    var pids = {};
    all(block, '[data-oz-tile]').forEach(function (tile) {
      var ck = tile.getAttribute('data-oz-ckey');
      if (ck && ck !== '0') { cards[ck] = true; }
      String(tile.getAttribute('data-oz-pids') || '').split(',').forEach(function (p) { if (p) { pids[p] = true; } });
      // a cart service tile listing the devices holds every device's card
      all(tile, 'option[data-oz-ckey]').forEach(function (o) { var k = o.getAttribute('data-oz-ckey'); if (k && k !== '0') { cards[k] = true; } });
    });
    pids[block.getAttribute('data-oz-main-pid')] = true;
    return { cards: cards, pids: pids };
  }
  function insertTiles(block, sec, page, source) {
    var holder = sec.querySelector('[data-oz-tiles]');
    var have = blockHas(block);
    var incart = set(block.getAttribute('data-oz-incart'));
    var isRow = sec.getAttribute('data-oz-layout') !== 'grid';
    var anchor = holder.querySelector('[data-oz-skel], [data-oz-more], [data-oz-sentinel]');
    var added = 0;
    all(page, '[data-oz-tile]').forEach(function (tile) {
      if (isRow && holder.querySelectorAll('[data-oz-tile]').length >= ROW_MAX) { return; }
      var ck = tile.getAttribute('data-oz-ckey');
      if (ck && ck !== '0' && have.cards[ck]) { return; }
      var pids = String(tile.getAttribute('data-oz-pids') || '').split(',').filter(Boolean);
      if (pids.some(function (p) { return have.pids[p] || incart[p]; })) { return; }
      tile.setAttribute('data-oz-src', String(source));
      pids.forEach(function (p) { have.pids[p] = true; });
      if (ck && ck !== '0') { have.cards[ck] = true; }
      var node = document.importNode(tile, true);
      if (anchor) { holder.insertBefore(node, anchor); } else { holder.appendChild(node); }
      added++;
    });
    return added;
  }
  function finishSection(sec) {
    all(sec, '[data-oz-skel], [data-oz-more], [data-oz-sentinel]').forEach(function (el) { el.parentNode.removeChild(el); });
    updateArrows(sec);
    // a cart section whose lazy pages all came back empty (sold out or in the cart since): no title over nothing
    if (blockOf(sec) && blockOf(sec).hasAttribute('data-oz-upsells-cart') && !sec.querySelector('[data-oz-tile]:not([hidden])')) { setHidden(sec, true); }
  }
  // "Loading more · N to go": N is the tiles not yet walked (data-oz-total less what first paint and the loaded pages
  // walked), so it counts down page by page and reaches 0 with the last page, whatever those pages drop
  function updateMore(sec) {
    var more = sec.querySelector('[data-oz-more]');
    if (!more) { return; }
    var total = Number(sec.getAttribute('data-oz-total')) || 0;
    var left = Math.max(0, total - sectionState(sec).accounted);
    var text = 'Loading more · ' + left + ' to go';
    if (left > 0) { if (more.textContent !== text) { more.textContent = text; } } else { setHidden(more, true); }
  }
  function loadNext(sec) {
    var block = blockOf(sec);
    var st = sectionState(sec);
    if (!block || st.loading || st.failed) { return Promise.resolve(); }
    if (!st.queue.length) { finishSection(sec); return Promise.resolve(); }
    var isRow = sec.getAttribute('data-oz-layout') !== 'grid';
    if (isRow && sec.querySelectorAll('[data-oz-tile]').length >= ROW_MAX) { st.queue = []; finishSection(sec); return Promise.resolve(); }
    var entry = st.queue.shift();
    st.loading = true;
    return loadPage(block, entry).then(function (page) {
      st.loading = false;
      st.accounted += Math.max(0, (Number(page.getAttribute('data-oz-n')) || 0) - (st.part[entry.source + ':' + entry.page] || 0));
      var added = page.hasAttribute('data-oz-gone') ? 0 : insertTiles(block, sec, page, entry.source);
      if (added) {
        if (current && current.root === block) {
          filterPopup(block, current.ctx, block.getAttribute('data-oz-incart'), false);
          repricePopup(block);
        } else {
          var basis = Number(block.getAttribute('data-oz-basis')) || 0;
          all(sec, '[data-oz-tile]').forEach(function (tile) { renderTilePrice(tile, basis); });
        }
        watchViews(sec);
      }
      updateMore(sec);
      updateArrows(sec);
      if (!st.queue.length) { finishSection(sec); closeIfEmpty(block); return null; }
      // an empty page, or still in view: keep going
      if (!added || near(sec)) { return loadNext(sec); }
      closeIfEmpty(block);
      return null;
    }, function (error) {
      st.loading = false;
      publishError('lazy_failed', error && error.message);
      if (error && error.skip && st.queue.length) { return loadNext(sec); }
      st.failed = true;
      st.queue = [];
      finishSection(sec);
      closeIfEmpty(block);
    });
  }
  // The open pop-up has no tile left for this button and nothing more can come: close it and continue
  function closeIfEmpty(block) {
    if (!current || current.root !== block) { return; }
    var ctx = current.ctx;
    var left = filterPopup(block, ctx, block.getAttribute('data-oz-incart'), false);
    if (left || anyPending(block, ctx.kind)) { return; }
    publishError('empty_open', 'nothing left after loading more');
    var was = hide();
    if (was) { was.ctx.proceed([]); }
  }
  // The grid's lazy marker: the first skeleton or "Loading more" line that is rendered. A marker with no box (display
  // none) measures as 0,0 and would look in view for ever, loading every page at once; jsdom renders no boxes at all,
  // so there the first marker is used as before.
  function lazyMarker(sec) {
    var list = all(sec, '[data-oz-skel], [data-oz-more], [data-oz-sentinel]');
    for (var i = 0; i < list.length; i++) { if (list[i].getClientRects().length) { return list[i]; } }
    return list[0] || null;
  }
  function near(sec) {
    if (sec.getAttribute('data-oz-layout') !== 'grid') {
      var row = sec.querySelector('.oz-up__row');
      return !!row && row.scrollLeft + row.clientWidth >= row.scrollWidth - 320;
    }
    var marker = lazyMarker(sec);
    if (!marker) { return false; }
    var box = marker.getBoundingClientRect();
    return box.top < (window.innerHeight || 800) + 400 && box.bottom > -400;
  }
  var lazyObserver = null;
  // The cart block never grows on its own: it sits above the Checkout button, so its lazy pages load only once the
  // shopper scrolls (the page, for a grid; the row itself, or its arrow, for a row), never at load.
  var scrolled = false;
  var afterScroll = [];
  function whenScrolled(fn) {
    if (scrolled) { fn(); return; }
    afterScroll.push(fn);
  }
  window.addEventListener('scroll', function () {
    if (scrolled) { return; }
    scrolled = true;
    afterScroll.splice(0).forEach(function (fn) { fn(); });
  }, { passive: true });
  function startLazy(block) {
    var inCart = block.hasAttribute('data-oz-upsells-cart');
    all(block, 'section[data-oz-sec]').forEach(function (sec) {
      var st = sectionState(sec);
      if (!st.queue.length) { return; }
      if (current && current.root === block && !sectionAllows(sec, current.ctx.kind)) { return; }
      if (sec.getAttribute('data-oz-layout') === 'grid') {
        var marker = lazyMarker(sec);
        if (marker && 'IntersectionObserver' in window) {
          if (!lazyObserver) {
            lazyObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (e) { if (e.isIntersecting) { var s = e.target.closest('section[data-oz-sec]'); if (s) { loadNext(s); } } });
            }, { rootMargin: '400px 0px' });
          }
          if (!marker.__ozLazyWatched) {
            marker.__ozLazyWatched = true;
            if (inCart) { whenScrolled(function () { lazyObserver.observe(marker); }); } else { lazyObserver.observe(marker); }
          }
        }
        if (!inCart && near(sec)) { loadNext(sec); }
      } else {
        var row = sec.querySelector('.oz-up__row');
        if (row && !row.__ozLazyWatched) {
          row.__ozLazyWatched = true;
          row.addEventListener('scroll', function () { if (near(sec)) { loadNext(sec); } }, { passive: true });
        }
        if (!inCart && row && (row.querySelectorAll('[data-oz-tile]').length < 5 || near(sec))) { loadNext(sec); }
      }
    });
  }
  // Row arrows (desktop): each shows only while there is somewhere to go, so the left one never sits over the first
  // tile at the start and the right one goes at the end (unless more tiles are still to come)
  function updateArrows(sec) {
    var row = sec.querySelector('.oz-up__row');
    if (!row) { return; }
    var arrows = all(sec, '[data-oz-arrow]');
    if (!arrows.length) { return; }
    var st = sectionState(sec);
    var max = row.scrollWidth - row.clientWidth;
    arrows.forEach(function (arrow) {
      var dir = Number(arrow.getAttribute('data-oz-arrow')) || 1;
      var off = dir < 0 ? row.scrollLeft <= 2 : (row.scrollLeft >= max - 2 && !st.queue.length && !st.loading);
      if (row.querySelectorAll('[data-oz-tile]').length <= 4 && !st.queue.length) { off = true; }
      setHidden(arrow, off);
    });
  }
  function watchArrows(block) {
    all(block, 'section[data-oz-sec]').forEach(function (sec) {
      var row = sec.querySelector('.oz-up__row');
      if (!row || row.__ozArrowsWatched || !sec.querySelector('[data-oz-arrow]')) { return; }
      row.__ozArrowsWatched = true;
      row.addEventListener('scroll', function () { updateArrows(sec); }, { passive: true });
      updateArrows(sec);
    });
  }
  function prefetch(block) {
    all(block, 'section[data-oz-sec]').forEach(function (sec) {
      var st = sectionState(sec);
      var entry = st.queue[0];
      var src = entry && srcOf(block, entry.source);
      if (src) { fetchPage(pageUrl(block, src, entry.page, block.getAttribute('data-oz-page-param'))).catch(function () { /* loaded later */ }); }
    });
  }
  function whenIdle(fn) {
    if (window.requestIdleCallback) { window.requestIdleCallback(fn, { timeout: 4000 }); } else { setTimeout(fn, 1500); }
  }

  /* ---------- the cart block (CONTRACTS 6.4) ---------- */
  function cartSection() { return document.querySelector('[data-section-type="cart"]'); }
  function addFromCart(tile) {
    var add = tile.querySelector('[data-oz-add]');
    if (!add || add.getAttribute('aria-busy') === 'true') { return; }
    add.setAttribute('aria-busy', 'true');
    var section = cartSection();
    var sectionId = section && section.getAttribute('data-section-id');
    var item = { id: Number(tile.getAttribute('data-oz-vid')), quantity: 1, properties: { _upsell: tile.getAttribute('data-oz-token') } };
    var body = { items: [item] };
    if (sectionId) { body.sections = sectionId; }
    var event = itemOf(tile, true);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }, function () { return { ok: r.ok, status: r.status, data: null }; });
    }).then(function (res) {
      if (!res.ok) {
        add.removeAttribute('aria-busy');
        if (res.status === 422) {
          publishError('add_422', 'variant ' + item.id);
          setHidden(tile, true);
        }
        return;
      }
      publish('oz_upsells:add', { v: 1, pl: 'c', items: [event] });
      var html = res.data && res.data.sections && sectionId ? res.data.sections[sectionId] : null;
      // the theme's in-place merge (assets/oz-cart.js) when the page has it: only what changed moves
      if (html && section && window.OzCart && typeof window.OzCart.apply === 'function' && window.OzCart.apply(html)) { add.removeAttribute('aria-busy'); return; }
      if (html && section) {
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector('[data-section-type="cart"]');
        if (fresh) {
          section.innerHTML = fresh.innerHTML;
          var count = fresh.getAttribute('data-item-count');
          if (count !== null) {
            section.setAttribute('data-item-count', count);
            all(document, '.header__cart-count').forEach(function (el) { el.textContent = count; });
          }
          section.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
          initBlocks();
          return;
        }
      }
      // no section HTML: let the theme re-render the cart itself
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    }, function () {
      add.removeAttribute('aria-busy');
    });
  }

  /* ---------- boundary: promotion windows and funnel ends passing on an open page (PLAN 9.3) ---------- */
  var boundaryTimer = 0;
  function boundary() {
    boundaryTimer = 0;
    var now = nowSec();
    var next = 0;
    var dirty = false;
    all(document, '[data-oz-tile][data-oz-price], [data-oz-row] input[data-oz-price], [data-oz-upsells-popup] option[data-oz-price], [data-oz-upsells-cart] option[data-oz-price], [data-oz-row] option[data-oz-price]').forEach(function (el) {
      var p = parseJson(el.getAttribute('data-oz-price'));
      if (!p || !p.at) { return; }
      if (now >= p.at) {
        el.setAttribute('data-oz-price', JSON.stringify(p.a ? { s: p.a, at: 0, a: null } : { s: p.s, at: 0, a: null }));
        dirty = true;
      } else if (!next || p.at < next) {
        next = p.at;
      }
    });
    all(document, '[data-oz-ends]').forEach(function (el) {
      var ends = Number(el.getAttribute('data-oz-ends')) || 0;
      if (!ends) { return; }
      if (now >= ends) {
        if (!el.hidden) {
          var input = el.querySelector('input.related_product_block_check_input');
          if (input && input.checked) { input.checked = false; fire(input, 'change'); }
          setPressed(el, false);
          el.hidden = true;
          dirty = true;
        }
      } else if (!next || ends < next) {
        next = ends;
      }
    });
    if (dirty) {
      all(document, '[data-oz-upsells-rows]').forEach(function (group) {
        var section = productSection(group);
        var form = section && section.querySelector('form[action*="/cart/add"] [name="id"]');
        var variant = form ? variantById(section, form.value) : null;
        if (variant) { recheckRows(group, variant); }
      });
      all(document, '[data-oz-upsells-popup], [data-oz-upsells-cart]').forEach(function (block) {
        if (current && current.root === block) { repricePopup(block); return; }
        var basis = Number(block.getAttribute('data-oz-basis')) || 0;
        all(block, '[data-oz-tile]').forEach(function (tile) { renderTilePrice(tile, basis); });
      });
    }
    if (next) {
      var wait = Math.min(Math.max(1, next - now), 86400) * 1000 + 250;
      boundaryTimer = setTimeout(boundary, wait);
    }
  }

  /* ---------- wiring ---------- */
  OzBuy.upsell = { decide: decide, open: open, walletTap: walletTap };

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) { return; }
    var add = target.closest('[data-oz-add]');
    if (add) {
      var tile = add.closest('[data-oz-tile]');
      if (!tile) { return; }
      if (tile.closest('[data-oz-upsells-cart]')) {
        event.preventDefault();
        addFromCart(tile);
        return;
      }
      if (current && current.root.contains(tile)) {
        event.preventDefault();
        setPressed(tile, add.getAttribute('aria-pressed') !== 'true');
        updateFoot(current.root);
      }
      return;
    }
    if (!current) {
      var arrowOutside = target.closest('[data-oz-arrow]');
      if (arrowOutside) { scrollRow(arrowOutside); }
      return;
    }
    if (target.closest('[data-oz-up-back]') || target.closest('[data-oz-up-close]')) { event.preventDefault(); cancelPopup(); return; }
    if (target.closest('[data-oz-up-continue]')) { event.preventDefault(); continuePopup(target.closest('[data-oz-up-continue]')); return; }
    var arrow = target.closest('[data-oz-arrow]');
    if (arrow) { scrollRow(arrow); }
  });
  function scrollRow(arrow) {
    var sec = arrow.closest('section[data-oz-sec]');
    var row = sec && sec.querySelector('.oz-up__row');
    if (!row) { return; }
    var dir = Number(arrow.getAttribute('data-oz-arrow')) || 1;
    row.scrollBy({ left: dir * Math.max(160, row.clientWidth - 80), behavior: 'smooth' });
    if (dir > 0) { loadNext(sec); }
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('select[data-oz-options]')) { return; }
    var option = select.options[select.selectedIndex];
    if (!option) { return; }
    var row = select.closest('[data-oz-row]');
    if (row) {
      applyRowOption(row, option);
      var group = row.closest('[data-oz-upsells-rows]');
      var section = productSection(row);
      var basis = group ? pageBasis(group, currentVariantOf(section), wantedQty(section)) : 0;
      renderRowPrice(row, basis);
      var input = row.querySelector('input.related_product_block_check_input');
      if (input && input.checked) { fire(input, 'change'); }
      return;
    }
    var tile = select.closest('[data-oz-tile]');
    if (!tile) { return; }
    applyTileOption(tile, option);
    var block = blockOf(tile);
    var b = block ? (block.__ozBasis || Number(block.getAttribute('data-oz-basis')) || 0) : 0;
    renderTilePrice(tile, b);
    if (current && block === current.root) { updateFoot(block); }
  });
  function currentVariantOf(section) {
    var input = section && section.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? variantById(section, input.value) : null;
  }

  document.addEventListener('variant:changed', function (event) {
    var section = productSection(event.target);
    var variant = event.detail && event.detail.variant;
    if (!section || !variant) { return; }
    rowGroups(section).forEach(function (group) { recheckRows(group, variant); });
    refreshPopupFor(section, variant);
  });

  function initBlocks() {
    all(document, '[data-oz-upsells-cart]').forEach(function (block) {
      startLazy(block);
      watchViews(block);
      watchArrows(block);
      whenIdle(function () { prefetch(block); });
    });
  }
  // The dialog lives in <body>, clear of any transformed ancestor; the section keeps a reference. Moved at once (this
  // file is deferred, so it runs before DOMContentLoaded), before Shopify's wallet element in its pinned foot comes to
  // life, so that element is never taken out and put back later.
  function adoptPopups() {
    all(document, '[data-section-type="product"]').forEach(function (section) {
      var root = section.querySelector('[data-oz-upsells-popup]');
      if (!root) { return; }
      section.__ozUpPopup = root;
      document.body.appendChild(root);
    });
  }
  function start() {
    adoptPopups();
    all(document, '[data-oz-upsells-rows]').forEach(watchViews);
    all(document, '[data-oz-upsells-popup]').forEach(function (root) {
      watchArrows(root);
      whenIdle(function () { prefetch(root); });
    });
    initBlocks();
    if (document.querySelector('[data-oz-upsells-ns-missing]')) { publishError('ns_missing', 'theme setting upsells_ns is empty'); }
    boundary();
  }
  // Back from the cart or checkout the page comes from the browser's memory as it was: read the cart again, so the
  // rows and the pop-up stop offering what was added since (AGREED-SPEC 6), a row hidden that way is switched off (the
  // running total follows), and the price basis is the cart's.
  function refreshFromCart() {
    var groups = all(document, '[data-oz-upsells-rows]');
    var roots = all(document, '[data-oz-upsells-popup]');
    if (!groups.length && !roots.length) { return; }
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) { return; }
        var snap = cartSnapshot(cart);
        roots.forEach(function (root) { applySnapshot(root, snap); });
        groups.forEach(function (group) {
          applySnapshot(group, snap);
          var variant = currentVariantOf(productSection(group));
          if (variant) { recheckRows(group, variant); }
        });
      }, function () { /* keep the page as it is */ });
  }
  // Warehouse re-renders the cart section after a quantity change: the new block needs its listeners
  document.documentElement.addEventListener('cart:rerendered', function () { setTimeout(initBlocks, 0); });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) { return; }
    if (current) { hide(); }
    refreshFromCart();
  });

  /* ---------- the option menu (2026-10-16) ----------
   * A card with several options (a tile in the pop-up or the cart block, an in-page row) carries the native
   * <select data-oz-options> (the source of truth, and the control without JavaScript) and, from Liquid, a button
   * [data-oz-optbtn] that opens this menu instead of the browser's raw list. The menu is one element in <body>, so no
   * scroll container of the pop-up or row carousel can clip it: under the button (flipped above when the space below
   * is short) from 600px, a bottom sheet with a dim backdrop on phones. Each option: its photo, its short name
   * (data-oz-label: the shared "for <phone>" ending left out), its price for the current cart basis, the chosen one
   * ticked; options hidden or disabled (in the cart, claimed by another row) are not listed. Choosing sets the select
   * and fires its change, so price, photo, title and the add button follow exactly as before. Closes on a click
   * outside, Escape, Tab, scrolling and resizing. Keyboard: arrows, Home / End, Enter or Space, Escape, type-ahead.
   * ARIA: the button has aria-haspopup="listbox" and aria-expanded; the menu is a listbox with
   * aria-activedescendant. */
  var optMenu = null; // { menu, list, sheet, backdrop, select, button, items, active, typed, typedAt }
  var optSeq = 0;

  function optLabel(o) { return o.getAttribute('data-oz-label') || o.textContent || ''; }
  function syncOptBtn(el) {
    var select = el && el.querySelector('select[data-oz-options]');
    var button = el && el.querySelector('[data-oz-optbtn]');
    if (!select || !button) { return; }
    var o = select.options[select.selectedIndex];
    if (!o) { return; }
    var label = optLabel(o);
    var span = button.querySelector('[data-oz-optbtn-label]');
    if (span && span.textContent !== label) { span.textContent = label; }
    button.setAttribute('aria-label', 'Choose: ' + label);
  }
  function optBasis(holder) {
    var row = holder.closest('[data-oz-row]');
    if (row) {
      var group = row.closest('[data-oz-upsells-rows]');
      var section = productSection(row);
      return group ? pageBasis(group, currentVariantOf(section), wantedQty(section)) : 0;
    }
    var block = blockOf(holder);
    return block ? (block.__ozBasis || Number(block.getAttribute('data-oz-basis')) || 0) : 0;
  }
  function optOpen(button) {
    var holder = button.closest('[data-oz-row], [data-oz-tile]');
    var select = holder && holder.querySelector('select[data-oz-options]');
    if (!select) { return; }
    optClose(false);
    var sheet = window.matchMedia('(max-width: 599px)').matches;
    var basis = optBasis(holder);
    var menu = document.createElement('div');
    menu.className = 'oz-optmenu' + (sheet ? ' oz-optmenu--sheet' : '');
    var list = document.createElement('div');
    list.className = 'oz-optmenu__list';
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    var titleEl = holder.querySelector('[data-oz-title]');
    list.setAttribute('aria-label', 'Choose: ' + (titleEl ? titleEl.textContent : 'option'));
    if (sheet) {
      var head = document.createElement('div');
      head.className = 'oz-optmenu__head';
      var h = document.createElement('b');
      h.textContent = 'Choose an option';
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'oz-optmenu__close';
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 6L6 18M6 6l12 12"/></svg>';
      x.addEventListener('click', function () { optClose(true); });
      head.appendChild(h);
      head.appendChild(x);
      menu.appendChild(head);
    }
    var items = [];
    var active = 0;
    optSeq += 1;
    all(select, 'option').forEach(function (o) {
      if (o.hidden || o.disabled) { return; }
      var item = document.createElement('div');
      item.className = 'oz-optmenu__opt';
      item.id = 'oz-opt-' + optSeq + '-' + items.length;
      item.setAttribute('role', 'option');
      var on = o.value === select.value;
      item.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) { active = items.length; item.classList.add('is-on'); }
      var art = document.createElement('span');
      art.className = 'oz-optmenu__art';
      var src = o.getAttribute('data-oz-img');
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        img.loading = 'lazy';
        art.appendChild(img);
      }
      // one line; a name longer than the row slides to show its end and back, as the sticky bar's configuration
      // does (snippets/oz-sticky-bar.liquid, assets/oz-pdp.js fitStickyConfig): a still copy with an ellipsis and a
      // moving copy, measured in optFit
      var name = document.createElement('span');
      name.className = 'oz-optmenu__name';
      var still = document.createElement('span');
      still.className = 'oz-optmenu__name-text';
      still.textContent = optLabel(o);
      var moving = document.createElement('span');
      moving.className = 'oz-optmenu__name-move';
      moving.setAttribute('aria-hidden', 'true');
      moving.textContent = optLabel(o);
      name.appendChild(still);
      name.appendChild(moving);
      var price = document.createElement('span');
      price.className = 'oz-optmenu__price';
      var steps = priceOf(o);
      if (steps) {
        var p = pick(steps, basis);
        price.innerHTML = '<b>' + money(p.final) + '</b>' + (p.was > 0 ? '<s>' + money(p.was) + '</s>' : '');
      }
      var tick = document.createElement('span');
      tick.className = 'oz-optmenu__tick';
      tick.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4.5 10.5l3.5 3.5 7.5-8"/></svg>';
      item.appendChild(art);
      item.appendChild(name);
      item.appendChild(price);
      item.appendChild(tick);
      item.addEventListener('click', function () { optChoose(o.value); });
      item.addEventListener('pointermove', function () { optActivate(items.indexOf(item), false); });
      list.appendChild(item);
      items.push(item);
    });
    if (!items.length) { return; }
    menu.appendChild(list);
    var backdrop = null;
    if (sheet) {
      backdrop = document.createElement('div');
      backdrop.className = 'oz-optmenu-backdrop';
      backdrop.addEventListener('click', function () { optClose(true); });
      document.body.appendChild(backdrop);
    }
    document.body.appendChild(menu);
    optMenu = { menu: menu, list: list, sheet: sheet, backdrop: backdrop, select: select, button: button, holder: holder, items: items, active: -1, typed: '', typedAt: 0 };
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('is-open');
    if (!sheet) { optPlace(); }
    optFit(items);
    optActivate(active, true);
    list.focus({ preventScroll: true });
    requestAnimationFrame(function () { if (optMenu && optMenu.menu === menu) { menu.classList.add('is-open'); } });
  }
  // under the button, its width at least; above it when the space below is short and the space above larger
  function optPlace() {
    if (!optMenu || optMenu.sheet) { return; }
    var m = optMenu.menu;
    var r = optMenu.button.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var width = Math.min(Math.max(r.width, 340), vw - 24);
    var left = Math.min(Math.max(12, r.left), vw - 12 - width);
    m.style.width = width + 'px';
    m.style.left = left + 'px';
    m.style.maxHeight = '';
    var natural = Math.min(m.scrollHeight, 360);
    var below = vh - r.bottom - 12;
    var above = r.top - 12;
    var up = natural + 6 > below && above > below;
    var room = Math.max(120, (up ? above : below) - 6);
    m.style.maxHeight = Math.min(360, room) + 'px';
    var h = Math.min(natural, room);
    m.style.top = (up ? r.top - 6 - h : r.bottom + 6) + 'px';
    m.classList.toggle('is-up', up);
  }
  // the names longer than their row get is-long and the distance to slide (CSS oz-optmenu-peek)
  function optFit(items) {
    items.forEach(function (item) {
      var box = item.querySelector('.oz-optmenu__name');
      var move = box && box.querySelector('.oz-optmenu__name-move');
      if (!move) { return; }
      box.classList.remove('is-long');
      box.style.removeProperty('--oz-shift');
      var overflow = move.getBoundingClientRect().width - box.clientWidth;
      if (overflow > 0.5) {
        box.style.setProperty('--oz-shift', -Math.ceil(overflow + 2) + 'px');
        box.classList.add('is-long');
      }
    });
  }
  function optActivate(i, scroll) {
    if (!optMenu || i < 0 || i >= optMenu.items.length) { return; }
    if (optMenu.active > -1 && optMenu.items[optMenu.active]) { optMenu.items[optMenu.active].classList.remove('is-active'); }
    optMenu.active = i;
    var item = optMenu.items[i];
    item.classList.add('is-active');
    optMenu.list.setAttribute('aria-activedescendant', item.id);
    if (scroll) { item.scrollIntoView({ block: 'nearest' }); }
  }
  function optChoose(value) {
    if (!optMenu) { return; }
    var select = optMenu.select;
    optClose(true);
    if (select.value === value) { return; }
    select.value = value;
    fire(select, 'change');
  }
  function optClose(refocus) {
    if (!optMenu) { return; }
    var m = optMenu;
    optMenu = null;
    m.menu.remove();
    if (m.backdrop) { m.backdrop.remove(); }
    m.button.setAttribute('aria-expanded', 'false');
    m.button.classList.remove('is-open');
    if (refocus) { m.button.focus({ preventScroll: true }); }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-oz-optbtn]');
    if (!button) { return; }
    event.preventDefault();
    if (optMenu && optMenu.button === button) { optClose(true); return; }
    optOpen(button);
  });
  document.addEventListener('pointerdown', function (event) {
    if (!optMenu) { return; }
    if (optMenu.menu.contains(event.target) || optMenu.button.contains(event.target)) { return; }
    if (optMenu.backdrop && optMenu.backdrop === event.target) { return; }
    optClose(false);
  }, true);
  // window, capture: before the pop-up's own keys (document, capture), so Escape closes the menu and not the pop-up
  window.addEventListener('keydown', function (event) {
    var key = event.key;
    if (!optMenu) {
      var b = event.target && event.target.closest && event.target.closest('[data-oz-optbtn]');
      if (b && (key === 'ArrowDown' || key === 'ArrowUp')) { event.preventDefault(); optOpen(b); }
      return;
    }
    var n = optMenu.items.length;
    var handled = true;
    if (key === 'Escape' || key === 'Esc') { optClose(true); }
    else if (key === 'Tab') { optClose(true); handled = false; }
    else if (key === 'ArrowDown') { optActivate(Math.min(n - 1, optMenu.active + 1), true); }
    else if (key === 'ArrowUp') { optActivate(Math.max(0, optMenu.active - 1), true); }
    else if (key === 'Home' || key === 'PageUp') { optActivate(0, true); }
    else if (key === 'End' || key === 'PageDown') { optActivate(n - 1, true); }
    else if (key === 'Enter' || key === ' ') {
      var item = optMenu.items[optMenu.active];
      if (item) { item.click(); }
    } else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
      var t = Date.now();
      optMenu.typed = (t - optMenu.typedAt > 700 ? '' : optMenu.typed) + key.toLowerCase();
      optMenu.typedAt = t;
      var start = optMenu.typed.length === 1 ? optMenu.active + 1 : optMenu.active;
      for (var k = 0; k < n; k++) {
        var j = (start + k) % n;
        if (optMenu.items[j].querySelector('.oz-optmenu__name-text').textContent.toLowerCase().indexOf(optMenu.typed) === 0) { optActivate(j, true); break; }
      }
    } else { handled = false; }
    if (handled) { event.preventDefault(); event.stopPropagation(); }
  }, true);
  document.addEventListener('scroll', function (event) {
    if (!optMenu || optMenu.sheet) { return; }
    if (event.target && event.target.nodeType === 1 && optMenu.menu.contains(event.target)) { return; }
    optClose(false);
  }, true);
  window.addEventListener('resize', function () { if (optMenu && !optMenu.sheet) { optClose(false); } });
  // the button follows the select, whoever changed it (the menu, a variant change, the pop-up's shuffle)
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('select[data-oz-options]')) { return; }
    syncOptBtn(select.closest('[data-oz-row], [data-oz-tile]'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
